module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_forshaga-3bf9d08724b8cdf1428fb5b4ad3f54ff.png";